module.exports = __webpack_public_path__ + "fonts/DINNextLTW23-Medium.57ed3580.woff2";